import { AbstractNpiSource } from './abstract-npi.source';
import { ApiClient } from '../../../api';
import { NpiSourceEnum, ProcessNpiBodyDto } from '../../../dto/recs.dto';
import { AdSet } from '../../../entities/ad-set';
import { BrowserObjectModel } from '../../browser-object-model';
import { Injectable } from '../../dependency-injection/decorators';

@Injectable()
export class DmdNpiSource extends AbstractNpiSource {
  public constructor (
    protected override readonly apiClient: ApiClient,
    private readonly browserObjectModel: BrowserObjectModel,
  ) {
    super(apiClient);
  }

  public getType (): NpiSourceEnum {
    return NpiSourceEnum.DMD;
  }

  protected async process (adSet: AdSet): Promise<ProcessNpiBodyDto> {
    const npiDetectorUrl = adSet.getSettings().getNpiDetectors()?.[ this.getType() ]?.url;

    if (!npiDetectorUrl) {
      return {
        encryptedNpi: undefined,
        aimId: undefined,
        source: this.getType(),
      };
    }

    const url = new URL(npiDetectorUrl);

    url.searchParams.set('client-origin', this.browserObjectModel.getWindow().location.origin);
    url.searchParams.set('timestamp', Date.now().toString());

    return new Promise((resolve) => {
      const messageHandler = ({ origin, data }): void => {
        const originUrl = new URL(npiDetectorUrl);
        originUrl.pathname = '';

        if (origin.replace(/\/$/, '') !== url.toString().replace(/\/$/, '')) {
          return;
        }

        const aimId = data?.aimId;

        clearTimeout(timeout);
        resolve({ aimId, encryptedNpi: undefined, source: this.getType() });
      };

      const timeout = setTimeout(() => {
        this.browserObjectModel.getWindow().removeEventListener('message', messageHandler, false);
        resolve({ aimId: undefined, encryptedNpi: undefined, source: this.getType() });
      }, 100);

      this.browserObjectModel.getWindow().addEventListener('message', messageHandler, false);

      const el = this.browserObjectModel.getDocument().createElement('iframe');
      el.setAttribute('style', 'display:none!important');
      el.setAttribute('src', url.toString());

      this.browserObjectModel.getDocument().body.appendChild(el);
    });
  }
}
